import React from 'react';
import { Link } from 'react-router-dom';
import './landing.css';
import useLegalPage from './useLegalPage';
import openExternal from './openExternal';
import LogoMark from './art/LogoMark';

// Generated from the LegalApp design canvas. Class names carry the "pp-" prefix
// so they never collide with the rest of the app's CSS.
export default function TermsPage() {
  const { rootRef, navTo } = useLegalPage('TermsPage');
  return (
    <div className="pp-pp" ref={rootRef}>
      <header className="pp-nav">
        <div className="pp-wrap" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "20px", minHeight: "76px" }}>
          <Link to="/" style={{ display: "flex", alignItems: "center", gap: "12px", textDecoration: "none" }} aria-label="LegalApp home">
            <LogoMark />
            <span className="pp-d" style={{ fontSize: "24px", fontWeight: "700", letterSpacing: "-0.01em", color: "#0B1B3F" }}>
              {"Legal"}
              <span style={{ color: "#1D5BD8" }}>
                {"App"}
              </span>
            </span>
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
            <Link to="/" className="pp-back" aria-label="Back to home">
              <svg viewBox="0 0 24 24" style={{ width: "18px", height: "18px" }} aria-hidden="true">
                <path className="pp-ic" d="M19 12H5M11 6l-6 6 6 6" />
              </svg>
              <span>
                {"Back"}
                <span className="pp-hide-sm">
                  {" to home"}
                </span>
              </span>
            </Link>
            <a className="pp-btn" href="https://wa.me/919582822225?text=Hi%2C%20I%27d%20like%20to%20book%20a%20demo%20of%20LegalApp." target="_blank" rel="noopener noreferrer" onClick={openExternal} title="Book a demo on WhatsApp">
              {"Book a demo"}
            </a>
          </div>
        </div>
      </header>
      <section style={{ background: "#F8FAFE", borderBottom: "1px solid #EDF1F8", padding: "clamp(48px, 7vw, 88px) 0 clamp(40px, 5vw, 64px)" }}>
        <div className="pp-wrap" style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <div className="pp-eyebrow" style={{ color: "#1D5BD8" }}>
            {"Legal"}
          </div>
          <h1 className="pp-d" style={{ fontSize: "clamp(44px, 6vw, 72px)", lineHeight: "1", fontWeight: "700", letterSpacing: "-0.02em", color: "#0B1B3F" }}>
            {"Terms of Use"}
          </h1>
          <p style={{ fontSize: "19px", color: "#5A6684" }}>
            {"LexOnAlgo Advisory Private Limited"}
          </p>
        </div>
      </section>
      <section style={{ padding: "clamp(48px, 6vw, 80px) 0 clamp(64px, 8vw, 104px)" }}>
        <div className="pp-wrap pp-layout">
          <nav className="pp-toc" aria-label="On this page">
            <div className="pp-eyebrow" style={{ fontSize: "12px", color: "#5A6684", padding: "0 8px 8px" }}>
              {"On this page"}
            </div>
            <a href="#s1" onClick={navTo}>
              <span className="pp-m">
                {"1"}
              </span>
              <span>
                {"Eligibility"}
              </span>
            </a>
            <a href="#s2" onClick={navTo}>
              <span className="pp-m">
                {"2"}
              </span>
              <span>
                {"Account Registration"}
              </span>
            </a>
            <a href="#s3" onClick={navTo}>
              <span className="pp-m">
                {"3"}
              </span>
              <span>
                {"Use of the Platform"}
              </span>
            </a>
            <a href="#s4" onClick={navTo}>
              <span className="pp-m">
                {"4"}
              </span>
              <span>
                {"Intellectual Property"}
              </span>
            </a>
            <a href="#s5" onClick={navTo}>
              <span className="pp-m">
                {"5"}
              </span>
              <span>
                {"Privacy"}
              </span>
            </a>
            <a href="#s6" onClick={navTo}>
              <span className="pp-m">
                {"6"}
              </span>
              <span>
                {"Copyright Protection"}
              </span>
            </a>
            <a href="#s7" onClick={navTo}>
              <span className="pp-m">
                {"7"}
              </span>
              <span>
                {"Disclaimer"}
              </span>
            </a>
            <a href="#s8" onClick={navTo}>
              <span className="pp-m">
                {"8"}
              </span>
              <span>
                {"Limitation of Liability"}
              </span>
            </a>
            <a href="#s9" onClick={navTo}>
              <span className="pp-m">
                {"9"}
              </span>
              <span>
                {"Indemnification"}
              </span>
            </a>
            <a href="#s10" onClick={navTo}>
              <span className="pp-m">
                {"10"}
              </span>
              <span>
                {"Termination"}
              </span>
            </a>
            <a href="#s11" onClick={navTo}>
              <span className="pp-m">
                {"11"}
              </span>
              <span>
                {"Governing Law"}
              </span>
            </a>
            <a href="#s12" onClick={navTo}>
              <span className="pp-m">
                {"12"}
              </span>
              <span>
                {"Dispute Resolution"}
              </span>
            </a>
            <a href="#s13" onClick={navTo}>
              <span className="pp-m">
                {"13"}
              </span>
              <span>
                {"Changes to These Terms"}
              </span>
            </a>
            <a href="#s14" onClick={navTo}>
              <span className="pp-m">
                {"14"}
              </span>
              <span>
                {"Contact Us"}
              </span>
            </a>
          </nav>
          <article className="pp-article">
            <div className="pp-sec">
              <p className="pp-lead">
                {"Welcome to LegalApp (\"we,\" \"us,\" \"our\"). These Terms of Use (\"Terms\") govern your access to and use of our platform. By accessing or using our platform, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not use our platform."}
              </p>
              <p>
                {"LegalApp is an AI assistant for investigating officers. It helps with complaint intake and FIR drafting, investigation planning, identifying and analysing evidence, identifying and questioning witnesses and accused persons, recording statements and drafting the case diary, and preparing notices and chargesheets. Complainants may also use LegalApp's guided complaint interface, and counsel for complainants and accused persons may use the platform in the course of their professional practice."}
              </p>
            </div>
            <div id="s1" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"01"}
                </span>
                <span>
                  {"Eligibility"}
                </span>
              </h2>
              <ul>
                <li>
                  {"You must be at least 18 years old or the legal age of majority in your jurisdiction to use our platform."}
                </li>
                <li>
                  {"By using our platform, you represent and warrant that you have the legal capacity to enter into these Terms."}
                </li>
              </ul>
            </div>
            <div id="s2" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"02"}
                </span>
                <span>
                  {"Account Registration"}
                </span>
              </h2>
              <ul>
                <li>
                  {"To access certain features of our platform, you may need to create an account."}
                </li>
                <li>
                  {"You agree to provide accurate, current, and complete information during registration and to update such information as necessary."}
                </li>
                <li>
                  {"You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account."}
                </li>
              </ul>
            </div>
            <div id="s3" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"03"}
                </span>
                <span>
                  {"Use of the Platform"}
                </span>
              </h2>
              <h3>
                <span className="pp-m">
                  {"3.1"}
                </span>
                {"Permitted Use"}
              </h3>
              <p>
                {"You may use our platform solely for lawful purposes and in accordance with these Terms. Subject to your compliance, you are permitted to:"}
              </p>
              <ul>
                <li>
                  <strong>
                    {"3.1.1 Investigation Assistance:"}
                  </strong>
                  {" Create or upload complaints, FIRs, statements, evidence, and other case records to generate AI-assisted outputs, such as FIR drafts, investigation plans, lists of potential evidence and witnesses, examination and interrogation questions, case diary entries, notices, and chargesheet drafts."}
                </li>
                <li>
                  <strong>
                    {"3.1.2 Case Preparation:"}
                  </strong>
                  {" Use the platform's outputs to analyse cases, identify key legal issues, assess the rights of the parties, map evidence, and prepare for proceedings."}
                </li>
                <li>
                  <strong>
                    {"3.1.3 Review and Verification:"}
                  </strong>
                  {" Outputs are suggestions for review. Investigating officers must review and verify every output and remain responsible for every decision and every document filed. Counsel must independently verify all outputs before relying on them in professional practice. Complainants and other litigants must consult a qualified advocate before acting on any output."}
                </li>
              </ul>
              <h3>
                <span className="pp-m">
                  {"3.2"}
                </span>
                {"Prohibited Activities"}
              </h3>
              <p>
                {"You must not:"}
              </p>
              <ul>
                <li>
                  {"Use the platform for any illegal or unauthorized purpose."}
                </li>
                <li>
                  {"Upload or process case data, including personal information about complainants, victims, witnesses, or accused persons, without lawful authority to do so."}
                </li>
                <li>
                  {"Use the platform to provide legal advice without independent verification by a qualified lawyer."}
                </li>
                <li>
                  {"Misrepresent AI-generated outputs as definitive, error-free, or a substitute for professional judgment."}
                </li>
                <li>
                  {"Exploit the platform for unlawful litigation tactics (e.g., frivolous claims, harassment)."}
                </li>
                <li>
                  {"Scrape, replicate, or commercially exploit the platform’s data or models without permission."}
                </li>
                <li>
                  {"Upload or share content that infringes on intellectual property rights, violates privacy, or is defamatory, obscene, or harmful."}
                </li>
                <li>
                  {"Attempt to gain unauthorized access to the platform, its systems, or other users’ accounts."}
                </li>
                <li>
                  {"Reverse engineer, decompile, or disassemble any part of the platform."}
                </li>
                <li>
                  {"Use automated tools, bots, or scraping technologies to access or interact with the platform."}
                </li>
              </ul>
            </div>
            <div id="s4" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"04"}
                </span>
                <span>
                  {"Intellectual Property"}
                </span>
              </h2>
              <h3>
                <span className="pp-m">
                  {"4.1"}
                </span>
                {"Ownership"}
              </h3>
              <ul>
                <li>
                  {"We retain all rights, title, and interest in and to the platform, including all intellectual property rights."}
                </li>
                <li>
                  {"You retain ownership of the case data and documents you upload."}
                </li>
              </ul>
              <h3>
                <span className="pp-m">
                  {"4.2"}
                </span>
                {"License"}
              </h3>
              <p>
                {"By uploading content to the platform, you grant us a non-exclusive, worldwide, royalty-free license to use, process, and analyse your content solely for the purpose of providing the platform's services to you."}
              </p>
            </div>
            <div id="s5" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"05"}
                </span>
                <span>
                  {"Privacy"}
                </span>
              </h2>
              <p>
                {"Your use of the platform is subject to our "}
                <Link to="/privacy">
                  {"Privacy Policy"}
                </Link>
                {", which explains how we collect, use, and protect your information."}
              </p>
            </div>
            <div id="s6" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"06"}
                </span>
                <span>
                  {"Copyright Protection"}
                </span>
              </h2>
              <ul>
                <li>
                  <strong>
                    {"Ownership of Content:"}
                  </strong>
                  {" All content, materials, software, trademarks, logos, designs, text, graphics, images, videos, and other intellectual property (collectively, the \"Content\") available on or through LegalApp’s platform are the exclusive property of LegalApp and are protected by applicable copyright, trademark, and other intellectual property laws."}
                </li>
                <li>
                  <strong>
                    {"Limited License:"}
                  </strong>
                  {" Subject to your compliance with these Terms of Use, LegalApp grants you a limited, non-exclusive, non-transferable, and revocable license to access and use the Content solely for your personal or internal business purposes in accordance with these Terms."}
                </li>
                <li>
                  <strong>
                    {"Restrictions on Use:"}
                  </strong>
                  {" You agree not to:\n            "}
                  <ul>
                    <li>
                      {"Copy, reproduce, modify, distribute, display, or create derivative works of the Content without express written permission from LegalApp."}
                    </li>
                    <li>
                      {"Reverse-engineer, decompile, disassemble, or attempt to derive the source code of any software provided by LegalApp."}
                    </li>
                    <li>
                      {"Remove or alter any copyright, trademark, or proprietary notices from the Content."}
                    </li>
                    <li>
                      {"Use the Content for any commercial purpose not expressly permitted by LegalApp."}
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    {"Termination for Violations:"}
                  </strong>
                  {" Any unauthorized use of the Content may result in immediate termination of your access to the platform and may subject you to legal action."}
                </li>
              </ul>
            </div>
            <div id="s7" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"07"}
                </span>
                <span>
                  {"Disclaimer"}
                </span>
              </h2>
              <ul>
                <li>
                  <strong>
                    {"Platform Use:"}
                  </strong>
                  {" The platform is provided “as is” and “as available” without warranties of any kind, either express or implied. Your use of the platform is at your sole risk."}
                </li>
                <li>
                  <strong>
                    {"Accuracy of Outputs:"}
                  </strong>
                  {" We do not guarantee the accuracy, completeness, or reliability of the insights, recommendations, drafts, or other outputs generated by the platform. These outputs are provided for informational purposes only and should not be construed as legal advice."}
                </li>
                <li>
                  <strong>
                    {"No Legal Advice:"}
                  </strong>
                  {" The platform is not a substitute for professional legal advice, consultation, or representation. Always seek the advice of a qualified attorney for any legal concerns or decisions."}
                </li>
                <li>
                  <strong>
                    {"AI Limitations:"}
                  </strong>
                  {" The platform utilizes Artificial Intelligence (AI) to generate outputs. While AI strives to provide accurate and relevant information, it may have limitations, including errors, biases, or outdated data. Users are responsible for verifying the outputs independently."}
                </li>
                <li>
                  <strong>
                    {"User Responsibility:"}
                  </strong>
                  {" You are solely responsible for any decisions or actions taken based on the outputs provided by the platform. We disclaim any liability for consequences arising from the use of or reliance on the platform’s outputs."}
                </li>
                <li>
                  <strong>
                    {"Changes to Platform:"}
                  </strong>
                  {" We reserve the right to modify, suspend, or discontinue any part of the platform at any time without prior notice. Fees, features, and functionalities may also be updated periodically."}
                </li>
                <li>
                  <strong>
                    {"No Endorsement:"}
                  </strong>
                  {" The use of the platform does not create an attorney-client relationship or any other professional relationship between you and the platform or its operators."}
                </li>
                <li>
                  <strong>
                    {"Jurisdictional Limitations:"}
                  </strong>
                  {" The platform may not be suitable or compliant with the laws of all jurisdictions. Users are responsible for ensuring compliance with local laws and regulations."}
                </li>
                <li>
                  <strong>
                    {"Data Privacy:"}
                  </strong>
                  {" While we take measures to protect your data, we cannot guarantee the security of information uploaded to the platform. By using the platform, you acknowledge and accept the risks associated with data transmission and storage."}
                </li>
              </ul>
            </div>
            <div id="s8" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"08"}
                </span>
                <span>
                  {"Limitation of Liability"}
                </span>
              </h2>
              <ul>
                <li>
                  {"To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the platform."}
                </li>
                <li>
                  {"Our total liability to you for any claim arising out of or related to these Terms or the platform shall not exceed the amount you paid to us in the last 12 months."}
                </li>
              </ul>
            </div>
            <div id="s9" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"09"}
                </span>
                <span>
                  {"Indemnification"}
                </span>
              </h2>
              <p>
                {"You agree to indemnify and hold us harmless from any claims, liabilities, damages, losses, or expenses arising out of or related to:"}
              </p>
              <ul>
                <li>
                  {"Your use of the platform."}
                </li>
                <li>
                  {"Your violation of these Terms."}
                </li>
              </ul>
            </div>
            <div id="s10" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"10"}
                </span>
                <span>
                  {"Termination"}
                </span>
              </h2>
              <ul>
                <li>
                  {"We may suspend or terminate your access to the platform at any time, with or without notice, for any reason."}
                </li>
                <li>
                  {"You may terminate your account at any time by contacting us."}
                </li>
                <li>
                  {"Upon termination, your right to use the platform will immediately cease."}
                </li>
              </ul>
            </div>
            <div id="s11" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"11"}
                </span>
                <span>
                  {"Governing Law"}
                </span>
              </h2>
              <p>
                {"These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law principles."}
              </p>
            </div>
            <div id="s12" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"12"}
                </span>
                <span>
                  {"Dispute Resolution"}
                </span>
              </h2>
              <ul>
                <li>
                  {"Any disputes arising out of or related to these Terms or the platform shall be resolved through binding arbitration in accordance with the provisions of the Arbitration and Conciliation Act, 1996."}
                </li>
                <li>
                  {"The arbitration shall take place in New Delhi, India, and the language of arbitration shall be English."}
                </li>
              </ul>
            </div>
            <div id="s13" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"13"}
                </span>
                <span>
                  {"Changes to These Terms"}
                </span>
              </h2>
              <p>
                {"We may update these Terms from time to time. Any changes will be posted on our platform. Your continued use of the platform constitutes acceptance of the revised Terms."}
              </p>
            </div>
            <div id="s14" className="pp-sec">
              <h2>
                <span className="pp-m">
                  {"14"}
                </span>
                <span>
                  {"Contact Us"}
                </span>
              </h2>
              <p className="pp-note">
                {"If you have any questions or concerns about these Terms, please email us at "}
                <a href="mailto:contact@legalapp.in">
                  {"contact@legalapp.in"}
                </a>
                {" or message us on WhatsApp at "}
                <a href="https://wa.me/919582822225" target="_blank" rel="noopener noreferrer" onClick={openExternal}>
                  {"+91 95828 22225"}
                </a>
                {"."}
              </p>
            </div>
          </article>
        </div>
      </section>
      <footer className="pp-foot" style={{ borderTop: "1px solid #DCE4F2", padding: "32px 0" }}>
        <div className="pp-wrap" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px 24px", fontSize: "14px", color: "#5A6684" }}>
          <span>
            {"© 2026 LexOnAlgo Advisory Pvt. Ltd. All rights reserved."}
          </span>
          <span style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
            <Link to="/">
              {"Home"}
            </Link>
            <Link to="/privacy">
              {"Privacy"}
            </Link>
            <a href="mailto:contact@legalapp.in">
              {"contact@legalapp.in"}
            </a>
            <a href="https://wa.me/919582822225" target="_blank" rel="noopener noreferrer" onClick={openExternal}>
              {"Support"}
            </a>
          </span>
        </div>
      </footer>

    </div>
  );
}
